import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LichSuGiaHanNgayTra = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
    TongTienThanhToan: 0,
  };
  const [dataLichSuGiaHanNgayTra, UpdateDataLichSuGiaHanNgayTra] =
    useState(dataInit);

  const DanhSachLichSuNoPhaiThu = (page) => {
    NhanVayApi.getLichSuGiaHanNgayTraNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSuGiaHanNgayTra({
        ...dataLichSuGiaHanNgayTra,
        List: response.data.List,
        TongTienThanhToan: response.data.TongTienThanhToan,
      });
    });
  };

  React.useEffect(() => {
    DanhSachLichSuNoPhaiThu(1);
  }, []);
  //End fix height tab

  const listItem = () => {
    return (
      dataLichSuGiaHanNgayTra.List != null &&
      dataLichSuGiaHanNgayTra.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td scope="row">{index + 1}</td>
              <td className="">{getDate(item.GiaHanChoKy)}</td>
              <td className="">{getDate(item.NgayGiaHan)}</td>
              <td className="">{getDate(item.NgayThanhToan)}</td>
              <td className="text-right">{formatNumber(item.TienThanhToan)}</td>
              <td className="text-left">{item.LyDo}</td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <>
      <div className="table-from-detailtl4">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="w-stt">STT</th>
                  <th className="">Gia hạn cho kỳ</th>
                  <th className="">Ngày gia hạn</th>
                  <th className="">Ngày phải thanh toán</th>
                  <th className="text-right">
                    Số tiền phải thanh toán
                    <br />  
                    <span className="red">
                      {formatNumber(dataLichSuGiaHanNgayTra.TongTienThanhToan)}
                    </span>
                  </th>
                  <th className="text-left">Lý do gia hạn</th>
                </tr>
              </thead>
              <tbody>{listItem()}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
